<template>
  <div id="gamesfilterN" class="games-filter-container" >
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="games-container-main">
            <div class="featured-games-header-text">
              <div class="games-title">
                <div class="games-title-dates" style="border-bottom: transparent">
                  <div class="header-row d-flex align-items-center" style="width: 100%">
                    <div class="sport-dropdown">
                      <select
                          id="selectedSportId"
                          v-model="selectedSportId"
                          @change="onSportChange"
                          aria-label="Select Sport"
                          style="border: 1px solid transparent; padding: 3px; width: 100%; background-color: var(--color-bg); color: var(--color-fg);"
                      >
                        <option disabled value="">Select sport</option>
                        <option v-for="sport in sports" :key="sport.id" :value="sport.id">
                          {{ sport.name }}
                        </option>
                      </select>
                    </div>
                    <div class="download-strip flex-fill p-1 d-flex justify-content-end align-items-center">
                      <strong class="strip-text" style="width: 100%; text-align: center">
                        Download the Maybets App!
                      </strong>
                      <a
                          :href="appLink"
                          class="btn btn-warning btn-sm btn-may"
                          target="_blank"
                          download
                      >
                        Download
                      </a>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="gamesfilter" class="games-filter-container" :style="{ top: stickyTopSize }">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="games-container-main">


            <div class="games-title">
              <div class="games-title-dates">
                <div class="games-hours">
                  <div class="cat-a">
                    <div class="cat-c" style="position: relative; display: inline-block;">
                      <select
                          aria-label="Select a Time Filter"
                          id="selectedTimeFilter"
                          style="border: 1px solid grey; padding: 3px; width: 100px; background-color: var(--color-bg); color: var(--color-fg);"
                          @change="updateTimeFilter($event)"
                      >
                        <option disabled selected value="">&nbsp;Filters</option>
                        <option value="highlights">Hot Games</option>
                        <option value="3">+3hrs</option>
                        <option value="6">+6hrs</option>
                        <option value="12">+12hrs</option>
                        <option value="today">Today</option>
                        <option value="tomorrow">Tomorrow</option>
                        <option value="countries">A-Z Countries</option>
                        <option value="highlights">All</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="games-days">
                  <div class="cat-b">
                    <div :class="['cat-d', { active: selectedFilter === 'today' }]" @click="selectFilter('today')">
                      <span class="cat-t">Today</span>
                    </div>
                    <div :class="['cat-d', { active: selectedFilter === 'tomorrow' }]" @click="selectFilter('tomorrow')">
                      <span class="cat-t">{{ tomorrow }}</span>
                    </div>
                    <div :class="['cat-d', { active: selectedFilter === 'dayAfterTomorrow' }]" @click="selectFilter('dayAfterTomorrow')">
                      <span class="cat-t">{{ dayName }}</span>
                    </div>
                  </div>

                  <div class="cat-a">
                    <div class="datepicker" data-bs-toggle="modal" data-bs-target="#calendar">
                      <i class="bi bi-calendar3"></i>
                      <span class="dropdown-icon">
                        <img src="https://storage.googleapis.com/maybet/site/assets/icons/arrow-down.svg" alt="Calendar Dropdown" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div id="countries" class="games-countries">
              <ul>
                <li class="country-cat" :class="{ active: allCategories }">
                  <div @click="selectAllCountries">
                    All <span class="cat-c">{{ totalGames }}</span>
                  </div>
                </li>
                <li
                  v-show="liveGames.games > 0"
                  class="country-cat"
                  :class="{ active: liveCategory }"
                >
                  <div @click="selectLive" class="live-container">
<!--                    <img-->
<!--                      :src="liveIcon"-->
<!--                      alt="Live Icon"-->
<!--                      class="live-icon"-->
<!--                    />-->
                    <span class="live-text">Live</span>
                    <span class="cat-c">{{ liveGames.games }}</span>
                  </div>
                </li>
                <li v-for="country in filterCountries" :key="country.category_id" class="country-cat" :class="{ active: selectedCountry === country.category_id }">
                  <div @click.prevent="selectCountry(country)">
                    {{ country.country_name }} <span class="cat-c">{{ country.games }}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Calendar @date-selected="handleDateSelected"></Calendar>
</template>

<script>
import dayjs from 'dayjs'
import fix from '@/services/fix.js'
import { useTabStore } from '@/stores/tab.js'
import Calendar from '@/components/Modals/Calender.vue'
import { useNavStore } from '@/stores/navclose.js'
import { useSportStore } from '@/stores/sport.js'

export default {
  name: 'GamesFilter',
  components: { Calendar },
  props: {
    selectedFilter: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      sports: [
        { id: 1, name: 'Soccer' },
        { id: 2, name: 'Basketball' },
        { id: 12, name: 'Rugby' },
        { id: 23, name: 'Volleyball' },
        { id: 5, name: 'Tennis' },
        { id: 3, name: 'Baseball' },
        { id: 35, name: 'Netball' },
        { id: 31, name: 'Badminton' },
        { id: 21, name: 'Cricket' },
        { id: 16, name: 'NFL' },
        { id: 117, name: 'MMA' },
        { id: 10, name: 'Boxing' },
        { id: 137, name: 'ESoccer' },
        { id: 4, name: 'IceHockey' },
        { id: 6, name: 'Handball' },
        { id: 137, name: 'Esoccer' }
      ],
      selectedSportId: '',
      selectedSport: '',
      androidLink: "https://play.google.com/store/apps/details?id=com.Maybets",
      iosLink: "https://apps.apple.com/app/maybets/id6636552978", // Replace with actual App Store link
      countries: [],
      highlights: [],
      liveGames: [],
      allLiveGames: [],
      selectedTime: '3hrs',
      selectedDayIndex: 0,
      selectedCountry: null,
      liveCategory: false,
      allCategories: true,
      tomorrow: '',
      dayName: '',
      navStore: useNavStore(),
      isLoading: false,
      currentChunk: 0
    }
  },
  created() {
    const storedSportId = localStorage.getItem('selectedSportId');
    if (storedSportId) {
      this.selectedSportId = Number(storedSportId);
      const sport = this.sports.find(s => s.id === this.selectedSportId);
      this.selectedSport = sport ? sport.name : 'Soccer';
    } else {
      this.selectedSportId = 1;
      this.selectedSport = 'Soccer';
      localStorage.setItem('selectedSportId', 1);
    }
    const sportStore = useSportStore();
    sportStore.updateSportId(this.selectedSportId);

    this.fetchCountries();
    this.updateDayFilter();
    this.fetchSports();
  },
  emits: [
    'update-hours',
    'update-days',
    'update-country',
    'filter-selected',
    'update-date',
    'sport-selected',
    'update-live'
  ],
  computed: {
    appLink() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/android/i.test(userAgent)) {
        return this.androidLink;
      } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
        return this.iosLink;
      } else {
        return this.androidLink; // Default to Android if OS is unknown
      }
    },
    liveIcon() {
      // Use toLowerCase to ensure case-insensitive matching.
      switch (this.selectedSport.toLowerCase()) {
        case 'soccer':
          return 'https://storage.googleapis.com/maybet/site/assets/icons/icon_soccer.svg';
        case 'basketball':
          return 'https://storage.googleapis.com/maybet/site/assets/icons/old/sport-icon-basketball.svg';
        case 'rugby':
          return 'https://storage.googleapis.com/maybet/site/assets/icons/sport-icon-rugby.svg';
        case 'volleyball':
          return 'https://storage.googleapis.com/maybet/site/assets/icons/sport-icon-volleyball.svg';
        case 'tennis':
          return 'https://storage.googleapis.com/maybet/site/assets/icons/sport-icon-tennis2.svg';
        case 'baseball':
          return 'https://storage.googleapis.com/maybet/site/assets/icons/sport-icon-baseball-ball.svg';
        case 'badminton':
          return 'https://storage.googleapis.com/maybet/site/assets/icons/icon_badminton.svg';
        case 'cricket':
          return 'https://storage.googleapis.com/maybet/site/assets/icons/cricket.svg';
        case 'nfl':
          return 'https://storage.googleapis.com/maybet/site/assets/icons/icon_americanfootball2.svg';
        case 'mma':
          return 'https://storage.googleapis.com/maybet/site/assets/icons/icon_mma2.svg';
        case 'boxing':
          return 'https://storage.googleapis.com/maybet/site/assets/icons/sport-icon-boxing2.svg';
        case 'esoccer':
          return 'https://storage.googleapis.com/maybet/site/assets/icons/old/box.svg';
        case 'icehockey':
          return 'https://storage.googleapis.com/maybet/site/assets/icons/sport-icon-ice-hockey2.svg';
        case 'handball':
          return 'https://storage.googleapis.com/maybet/site/assets/icons/icon_handball2.svg';
        default:
          return 'https://storage.googleapis.com/maybet/site/assets/icons/icon_soccer.svg';
      }
    },
    filterCountries() {
      if (this.countries && this.countries.length > 0) {
        return this.countries.filter(country => country.games > 0);
      }
      return [];
    },
    stickyTopSize() {
      return this.navStore.isNavClosed ? '2.5rem' : '3.15rem';
    },
    sportId() {
      const sportStore = useSportStore();
      return sportStore.getSportId;
    },
    totalGames() {
      return this.filterCountries.reduce((sum, country) => sum + country.games, 0);
    },
    displaySport() {
      return this.selectedSport === 'American Football'
          ? 'A.Football'
          : this.selectedSport || 'Sports';
    }
  },
  watch: {
    '$route.params.sport_name': {
      immediate: true,
      handler(newValue) {
        this.selectedSport = newValue || 'Football';
        const sport = this.sports.find(s => s.name === this.selectedSport);
        if (sport) {
          this.selectedSportId = sport.id;
          localStorage.setItem('selectedSportId', sport.id);
        }
        this.fetchCountries();
        this.fetchSports();
        this.setSelectedSportFromRoute(newValue);
      }
    }
  },
  methods: {
    async fetchCountries() {
      try {
        const url = `/categories/${this.sportId}`;
        const response = await fix.get(url);
        this.countries = response.data;
      } catch (error) {
        console.error('Failed to fetch countries:', error);
      }
    },
    async fetchSports() {
      try {
        const response = await fix.get(`/live/counter`);
        if (response && response.data && (response.data.sports !== null || undefined)) {
          const data = response.data.sports;
          this.allLiveGames = response.data.total;
          const currentSportId = parseInt(this.sportId);
          const currentSport = data.find(item => item.sport_id === currentSportId);
          this.liveGames = currentSport ? currentSport : [];
        }
      } catch (error) {
        console.error('Failed to fetch sports data:', error);
      }
    },
    selectCountry(country) {
      const tabStore = useTabStore();
      tabStore.setCategoryId(country.category_id);
      this.selectedCountry = country.category_id;
      this.allCategories = false;
      this.liveCategory = false;
      this.$emit('update-country', country);
    },
    selectAllCountries() {
      this.liveCategory = false;
      this.selectedCountry = null;
      this.allCategories = true;
      this.$emit('update-country', { category_id: 0 });
    },
    selectLive() {
      this.liveCategory = true;
      this.selectedCountry = null;
      this.allCategories = false;
      this.$emit('update-live', 'live');
    },
    onSportChange(event) {
      const sportId = Number(event.target.value);
      const sport = this.sports.find(s => s.id === sportId);
      if (sport) {
        this.selectedSport = sport.name;
        localStorage.setItem('selectedSportId', sportId);
        const sportStore = useSportStore();
        sportStore.updateSportId(sportId);
        this.$router.push({ name: 'sport', params: { sport_name: sport.name } });
        this.$emit('sport-selected', sport.name);
      }
    },
    setSelectedSportFromRoute(sportName) {
      const sportStore = useSportStore();
      const sport = this.sports.find(s => s.name === sportName);
      const sportId = sport ? sport.id : 1;
      sportStore.updateSportId(sportId);
    },
    updateTimeFilter(event) {
      const hours = event.target.value;
      this.$emit('update-hours', hours);
    },
    updateDayFilter() {
      const dayAfterTomorrow = dayjs().add(2, 'day');
      const tom = dayjs().add(1, 'day');
      this.tomorrow = tom.format('ddd');
      this.dayName = dayAfterTomorrow.format('ddd');
      const dayDate = dayAfterTomorrow.format('YYYY-MM-DD');
      this.$emit('update-days', dayDate);
    },
    selectFilter(filter) {
      if (filter === 'dayAfterTomorrow') {
        const dayAfterTomorrowDate = dayjs().add(2, 'day').format('YYYY-MM-DD');
        this.$emit('update-date', dayAfterTomorrowDate);
        this.$emit('filter-selected', filter);
      } else {
        this.$emit('filter-selected', filter);
      }
    },
    handleDateSelected(date) {
      this.$emit('update-date', date);
      this.$emit('filter-selected', 'date');
    }
  }
}
</script>

<style scoped>
.country-cat {
  cursor: pointer;
}

.live-container {
  color: red;
  display: flex;
  align-items: center;
}

.live-icon {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}

.cat-d {
  cursor: pointer;
}

.cat-d.active {
  border-bottom: 2px solid #8faf37;
}

.cat-d.active .cat-t {
  color: var(--color-fg);
}

.header-row {
  display: flex;
  align-items: center;
  gap: 30px;
}

.sport-dropdown {
  flex: 0 0 100px;
}

.download-strip {
  flex: 1;
  font-size: 11px;
  font-weight: bold;
  gap: 5px;
  background-color: #8faf37;
  border-radius: 4px;
  /*margin-bottom: 0; */
  padding: 0.25rem;
  border-bottom: 1px solid #ccc;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-may {
  font-size: 12px;
  font-weight: bold;
}

@media only screen and (max-width: 450px) {
  .header-row {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .download-strip {
    flex: 1;
    font-size: .65em;
    font-weight: bold;
    background-color: #8faf37;
    border-radius: 4px;
    color: black;
    /* margin-bottom: 0; */
    padding: 0.25rem;
    border-bottom: 1px solid #ccc;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .btn-may {
    font-size: 8px;
  }
}

/* Dropdown Styles */
.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-toggle {
  background: none;
  border: 1px solid grey;
  padding: 5px 10px;
  cursor: pointer;
  font-size: inherit;
  color: inherit;
  display: flex;
  align-items: center;
}

.dropdown-icon {
  margin-left: 0.5rem;
}

.dropdown-menu {
  position: absolute;
  left: 0;
  top: 100%;
  background-color: var(--color-bg);
  border: 1px solid grey;
  list-style: none;
  padding: 0.5rem 0;
  margin: 0;
  z-index: 1000;
  width: 100%;
}

.dropdown-menu li {
  padding: 0.5rem 1rem;
  cursor: pointer;
}

.dropdown-menu li:hover {
  background-color: #f1f1f1;
}
</style>